import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  mainPage: {
    height: '100%',
    margin: '0',
    overflow: 'hidden',
  },

  containerMainPage: {
    position: 'relative',
    minHeight: '100vh',
    letterSpacing: '-1px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F5F5F5',
  },

  contentApplicationReports: {
    minHeight: 'calc(100vh - 180px)',
    padding: '30px 5%',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
  },

  formContainer: {
    margin: '0px',
    padding: '35px 40px 35px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--main-bg-color)',
    borderRadius: '15px',
  },

  applicationReportsTable: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    paddingBottom: '20px',
    gap: '15px',
  },

  tableContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
  },

  tableCell: {
    '&:hover': { backgroundColor: '#e6f4ff', cursor: 'pointer' },
    '& td': {
      borderBottom: '1px solid #f0f0f0',
      color: 'rgba(0,0,0,0.88)',
      fontSize: '15px',
    },
    '&:last-child td': { borderBottom: '1px solid #f0f0f0' },
  },

  navButtonSx: () => ({
    border: '1px solid #d9d9d9',
    borderRadius: '6px',
    width: 32,
    height: 32,
    '&:hover:not(:disabled)': { borderColor: '#1677ff', color: '#1677ff' },
  }),

  tablePaginationForm: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 0.5,
    mt: 2,
    mb: 1,
  }),

  tablePaginationFormButton: () => ({
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(0,0,0,0.45)',
  }),

  tableCellHeader: () => ({
    fontWeight: 600,
    borderBottom: '1px solid #f0f0f0',
    color: 'rgba(0,0,0,0.88)',
    fontSize: '15px',
  }),

  table: () => ({
    border: 'none',
    width: '100%',
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#fafafa',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
      color: 'rgba(0,0,0,0.88)',
      fontSize: '15px',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: '1px solid #f0f0f0',
    },
    '& .MuiDataGrid-sortIcon': {
      opacity: '1 !important',
    },
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
      opacity: '0.3 !important',
    },
    '& .MuiDataGrid-row': {
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#e6f4ff',
      },
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid #f0f0f0',
      color: 'rgba(0,0,0,0.88)',
      fontSize: '15px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: '1.4',
      display: 'flex',
      alignItems: 'center',

      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
  }),

  resetFiltersContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    mb: 1,
  },

  sort: () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    mb: 2,
  }),

  sortTable: () => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  }),

  sortTableText: () => ({
    minWidth: 60,
    fontSize: 13,
  }),

  applicationReportButton: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
  }),

  applicationReportActionCell: () => ({
    display: 'inline-flex',
  }),

  applicationReportActionButton: () => ({
    minWidth: { xs: 40, sm: 130 },
    px: { xs: 1, sm: 1.5 },
  }),

  applicationReportActionIcon: () => ({
    display: 'inline-flex',
    mr: { xs: 0, sm: 1 },
  }),

  applicationReportActionLabel: () => ({
    display: { xs: 'none', sm: 'inline' },
  }),
};
